import { map, Observable } from 'rxjs';

export interface PaginatedResult<T> {
  items: T[];
  total: number;
}

export type ToInfiniteQueryResult<T> = PaginatedResult<T> & {
  previousPage: number | undefined;
  hasNextPage: boolean;
  nextPage: number | undefined;
  hasPreviousPage: boolean;
};

export function toInfiniteQuery<T>(params: {
  page?: number;
  limit?: number;
}): (query: Observable<PaginatedResult<T>>) => Observable<ToInfiniteQueryResult<T>> {
  return (query: Observable<PaginatedResult<T>>) =>
    query.pipe(
      map((result: PaginatedResult<T>) => {
        const page = params.page ?? 0;
        const limit = params.limit ?? 10;

        const hasNextPage = result.total > (page + 1) * limit;
        const hasPreviousPage = page > 0;

        const response = {
          ...result,
          nextPage: hasNextPage ? page + 1 : undefined,
          previousPage: hasPreviousPage ? page - 1 : undefined,
          hasNextPage: hasNextPage,
          hasPreviousPage: hasPreviousPage
        };

        return response;
      })
    );
}
